import { render, staticRenderFns } from "./header-end.vue?vue&type=template&id=5567cb7a"
import script from "./header-end.vue?vue&type=script&lang=js"
export * from "./header-end.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports